import { useEffect, useState } from "react";
import { Card, Flex } from "antd";
import { NumberParam, StringParam, withDefault } from "use-query-params";

import { FILTER_KEYS } from "constants/table";
import { FIELD_KEYS, FIELD_ORDERS, TABLE_FIELDS } from "constants/ItemFields";
import { useProduct } from "hooks/useProduct";
import {
  DateRangeArrayParam,
  NumberArrayParam,
  SorterArrayParam,
  useQueryParamsWithProducts,
} from "functions/queryParamFuncs";
import ItemTable from "components/ItemList/ItemTable";
import ItemTableFooter from "components/ItemList/ItemTableFooter";
import ItemTableHeader from "components/ItemList/ItemTableHeader";
import useFetch from "hooks/useFetch";
import useExport from "hooks/useExport";

const ItemListPage = () => {
  const {
    loading,
    responseData: itemListResponseData,
    doFetch: getItemList,
  } = useFetch("/items/getItemList", "GET", []);
  const { selectedProductIds } = useProduct();
  const [queryParams, setQueryParams] = useQueryParamsWithProducts(
    selectedProductIds,
    {
      [FIELD_KEYS.START_DATE_TIME]: withDefault(DateRangeArrayParam, []),
      [FIELD_KEYS.STATUS]: withDefault(NumberArrayParam, []),
      [FILTER_KEYS.SEARCH]: withDefault(StringParam, ""),
      [FILTER_KEYS.PAGE]: withDefault(NumberParam, 1),
      [FILTER_KEYS.PAGE_SIZE]: withDefault(NumberParam, 10),
      [FILTER_KEYS.SORTERS]: SorterArrayParam,
    }
  );
  const [filters, setFilters] = useState({
    ...queryParams,
    products: selectedProductIds,
  });
  const {
    responseData: responseDataForExport,
    doFetch: getItemListForExport,
    doExport: exportToCSV,
  } = useExport("/items/getItemList", "GET", [])

  const updateFilters = (newFilters) => {
    setFilters({
      ...filters,
      ...newFilters,
    });
  };
  if (selectedProductIds.toString() !== filters.products.toString()) {
    updateFilters({ products: selectedProductIds });
  }

  const tableData = itemListResponseData.items ?? [];
  const tableDataTotalCount = itemListResponseData.total_count ?? 0;
  const exportData = responseDataForExport.items ?? [];

  const fetchItemListData = () => {
    getItemList({
      ...filters,
      [FIELD_KEYS.START_DATE_TIME]: DateRangeArrayParam.encode(
        filters[FIELD_KEYS.START_DATE_TIME]
      ),
      [FILTER_KEYS.SORTERS]: SorterArrayParam.encodeApi(
        filters[FILTER_KEYS.SORTERS]
      ),
    });
  };

  const fetchUnitListForExport = () => {
    getItemListForExport({
      ...filters,
      [FIELD_KEYS.START_DATE_TIME]: DateRangeArrayParam.encode(
        filters[FIELD_KEYS.START_DATE_TIME]
      ),
      [FILTER_KEYS.SORTERS]: SorterArrayParam.encodeApi(
        filters[FILTER_KEYS.SORTERS]
      ),
      [FILTER_KEYS.PAGE_SIZE]: tableDataTotalCount,
    })
  }

  useEffect(() => {
    setQueryParams(filters);
    fetchItemListData();
  }, [filters]);

  useEffect(()=>{
    if(exportData.length > 0){
      exportToCSV(exportData, "Item list", TABLE_FIELDS, FIELD_ORDERS)
    }
  },[exportData])

  return (
    <>
      <div className="item-list-page">
        <Card>
          <Flex vertical={true} gap="middle" wrap="wrap">
            <ItemTableHeader
              filters={filters}
              tableDataTotalCount={tableDataTotalCount}
              loading={loading}
              onFiltersChange={updateFilters}
              fetchUnitListForExport={fetchUnitListForExport}
            />
            <ItemTable tableData={tableData} loading={loading} />
            <ItemTableFooter
              filters={filters}
              tableDataTotalCount={tableDataTotalCount}
              loading={loading}
              onFiltersChange={updateFilters}
            />
          </Flex>
        </Card>
      </div>
    </>
  );
};

export default ItemListPage;
